import { useConfigStore } from '@/stores';
import type { ListTypeListItem } from '@/types/list-type';

export const useCustomMenuContent = (id?: string) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const listBuildingMenus = useConfigStore((state) => state.config.server?.buildingMenus);
    const buildingMenus = listBuildingMenus?.[language];

    if (!id) return [];
    const customMenus = buildingMenus?.find((item) => item.id === id);

    return customMenus?.customContent?.sort((a: ListTypeListItem, b: ListTypeListItem) => b.sortOrder - a.sortOrder) ?? [];
};

